export function getSubscriptionStatus(student) {
  if (!student) return 'inactive';
  // Legacy: if student has active subscriptions via subscriptions table they're counted separately
  if (!student.subscription_end) return student.subscription_status || 'inactive';
  const now   = new Date();
  const end   = new Date(student.subscription_end);
  const grace = student.grace_period_end ? new Date(student.grace_period_end) : null;
  if (now <= end) return 'active';
  if (grace && now <= grace) return 'grace';
  return 'expired';
}

export function canWriteEssay(student) {
  // Candidates (localStorage-based, non-academy) are always allowed if tier permits
  if (!student?.subscription_end) return true;
  return getSubscriptionStatus(student) === 'active';
}

export function canViewMaterials(student) {
  const s = getSubscriptionStatus(student);
  return s === 'active' || s === 'grace';
}

export function getDaysRemaining(student) {
  if (!student?.subscription_end) return null;
  const now  = new Date();
  const end  = new Date(student.subscription_end);
  return Math.max(0, Math.ceil((end - now) / 86400000));
}

export function getGraceDaysRemaining(student) {
  if (!student?.grace_period_end) return 0;
  const now   = new Date();
  const grace = new Date(student.grace_period_end);
  return Math.max(0, Math.ceil((grace - now) / 86400000));
}
